/* eslint-disable relay/unused-fields */
import { useToggle } from "@react-hookz/web";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { SearchResultListToggle } from "scmp-app/components/search/search-result-panel/search-result-list/search-result-list-toggle";
import type { TopicEdge } from "scmp-app/components/search/types";
import type { topicSearchResultListTopicSearchConnection$key } from "scmp-app/queries/__generated__/topicSearchResultListTopicSearchConnection.graphql";

import { Container, StyledTopicSearchResultListItem, TopicSectionTitle } from "./styles";

export type Props = {
  reference: topicSearchResultListTopicSearchConnection$key;
};

export const TopicSearchResultList: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const topics = useFragment<topicSearchResultListTopicSearchConnection$key>(
    graphql`
      fragment topicSearchResultListTopicSearchConnection on TopicSearchConnection {
        edges {
          node {
            score
            content {
              entityId
              ...topicSearchResultListItemTopic
            }
          }
        }
      }
    `,
    reference_,
  );

  const handleRenderSuggestedTopicItem = (edge?: TopicEdge) => {
    if (!edge?.node?.content?.entityId) return null;
    return (
      <StyledTopicSearchResultListItem
        key={edge.node.content.entityId}
        reference={edge.node.content}
      />
    );
  };

  const [isExpand, toggleIsExpand] = useToggle();
  return topics.edges.length > 0 ? (
    <Container>
      <TopicSectionTitle>Topic:</TopicSectionTitle>
      {isExpand
        ? topics?.edges?.map(edge => handleRenderSuggestedTopicItem(edge))
        : handleRenderSuggestedTopicItem(topics?.edges[0])}
      {topics.edges.length > 1 && (
        <SearchResultListToggle
          isExpand={isExpand}
          onClick={() => toggleIsExpand()}
          toggleMessage={{
            after: "Show less",
            before: "Show all topics",
          }}
        />
      )}
    </Container>
  ) : null;
};

TopicSearchResultList.displayName = "TopicSearchResultList";
